import { splitShipmentDiscountSchema } from "@redotech/redo-fulfillment-settings/split-shipment-discount";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateSplitShipmentDiscount = unaryRpc({
  name: "updateSplitShipmentDiscount" as const,
  input: z.object({
    teamId: zExt.objectId(),
    settings: splitShipmentDiscountSchema,
    shippingSnapshot: z.string().length(64).optional(),
    confirmedReservedRateNames: z.boolean().optional(),
  }),
  output: z.object({ settings: splitShipmentDiscountSchema }),
});
